module.exports = __webpack_public_path__ + "static/media/need-network.c435c8df.jpg";